import { render, staticRenderFns } from "./customize-options.vue?vue&type=template&id=57a4dd64&scoped=true"
import script from "./customize-options.vue?vue&type=script&lang=js"
export * from "./customize-options.vue?vue&type=script&lang=js"
import style0 from "./customize-options.vue?vue&type=style&index=0&id=57a4dd64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a4dd64",
  null
  
)

export default component.exports